import * as Yup from 'yup'
import { FormItemProps } from '@/components/Form/types'

import React from 'react'
import HatchPatterList from '@/components/HatchProfile/HatchPatterList'


const items: Array<FormItemProps> = [
	{
		name: 'id',
		type: 'Hidden',
	},

	{
		name: 'name',
		label: 'Name',
		placeholder: 'Enter laser profile name',
		type: 'Text',
		classNames: {container: 'col-span-12'},
		validation: Yup.string().required('Name is required'),
	},
	{
		name: 'description',
		label: 'Description',
		placeholder: 'Enter description',
		type: 'LongText',
		classNames: {container: 'col-span-12'},
	},
	{
		name: 'hatch_patterns',
		label: 'Hatch Patterns',
		type: 'Preview',
		itemOptions: {
			preview: (props: any) => (
				<HatchPatterList {...props} />
			),
		},
		classNames: {container: 'col-span-12'},
	}

]


export default items